import React from 'react'
import { Box } from '@mui/material'
import sxs from './_sxs'
import { NotificationWrapperProps } from './_props'
import { defaultPalette } from '../../../theme/idsTheme'

const defaultSize = '1rem'

const NotificationWrapper: React.FC<NotificationWrapperProps> = ({ bubbleProps, children, active }) => (
    <Box sx={sxs.NotificationWrapper}>
        {children}
        {active && (
            <Box
                sx={[
                    sxs.NotificationWrapperBubble,
                    {
                        width: bubbleProps?.size ?? defaultSize,
                        height: bubbleProps?.size ?? defaultSize,
                        background: bubbleProps?.color ?? defaultPalette.orangeWarning.main,
                    },
                ]}
            />
        )}
    </Box>
)

export default NotificationWrapper
